import { Component,  Input, EventEmitter, Output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'black-bar-wrapper',
    template: `
<div class="bb-header">
  <div style="flex:1"></div>
  <ng-content select=".header"></ng-content>
  <div style="flex:1"></div>
  <div *ngIf="!noClose" class="bb-close" (click)="close.emit()">
    <icon matIcon="close"></icon>
  </div>
</div>
<div class="bb-content">
  <ng-content></ng-content>
</div>
`,
    styleUrls: ['./black-bar-wrapper.scss'],
    standalone: true,
    imports: [IconComponent, CommonModule],
})
export class BlackBarWrapperComponent {
  @Input() noClose
  @Output() close: EventEmitter<void> = new EventEmitter()
}



